import ManageItems from './Containers/manage-item-repair';
import ManageProblems from './Containers/manage-problem';

export default [
  {
    path: '/manage-items',
    component: ManageItems,
    private: true,
    menu: {
      name: 'Items to repair',
      group: 'Admin',
      icons: 'icon-items-to-repair-ic',
      order: 3,
      subGroup: 'Other'
    }
  },
  {
    path: '/items/problems/:itemId',
    component: ManageProblems,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/Items/routes.js